export enum Options {
  PAGE = 'page',
  TOPBAR = 'top-bar',
  MENU = 'menu',
  SIDE_NAVIGATION = 'side-navigation',
  DND_MOVING_ITEM = 'dnd-moving-item',
  MOBILE_NAVIGATION = 'mobile-navigation',
  SIDE_NAVIGATION_BACKDROP = 'side-navigation-backdrop',
  MOBILE_ADD_BUTTON = 'mobile-add-button',
  DETAIL_COLUMN = 'detail-column',
  // covers a locked feature's own layered UI (the timeline's sticky columns, drag layers)
  PREMIUM_OVERLAY = 'premium-overlay',
  DIALOG = 'dialog',
  TOOLTIP = 'tooltip',
  // a modal raised from inside a popup — must cover the PopupMenu that spawned it, which
  // deliberately sits above DIALOG so selects inside ordinary dialogs still work
  POPUP_DIALOG = 'popup-dialog',
  BOTTOM_RIGHT_MESSAGE = 'bottom-right-message',
  // above dialogs: a habit completed from the task detail dialog still shows its progress
  PROGRESS_BANNERS = 'progress-banners',
  DOWNLOAD_APP_BANNER = 'download-app-banner',
  // Top of the stack, deliberately: covers BOTTOM_RIGHT_MESSAGE, and no onboarding step opens a dialog.
  ONBOARDING_OVERLAY = 'onboarding-overlay',
}

const order = [
  Options.PAGE,
  Options.MENU,
  Options.TOPBAR,
  Options.SIDE_NAVIGATION_BACKDROP,
  Options.SIDE_NAVIGATION,
  Options.DND_MOVING_ITEM,
  Options.MOBILE_NAVIGATION,
  Options.MOBILE_ADD_BUTTON,
  Options.DETAIL_COLUMN,
  Options.PREMIUM_OVERLAY,
  Options.DOWNLOAD_APP_BANNER,
  Options.DIALOG,
  Options.TOOLTIP,
  Options.POPUP_DIALOG,
  Options.BOTTOM_RIGHT_MESSAGE,
  Options.PROGRESS_BANNERS,
  Options.ONBOARDING_OVERLAY,
];

export function index(option: Options): number {
  return order.findIndex((value) => value === option);
}
